/* eslint-disable func-names, max-len, no-new, no-underscore-dangle */
if ($('.social-section').length > 0) {
  // social tabs
  (function () {
    // adds active to the first tab
    $('.social-section .tabs div:first-of-type').addClass('active-tab');
    // show the first tab content
    $('.social-section .tab-main .tab:first-of-type').show();

    $('.social-section .tabs div').click(function () {
      // on click of a tab check if its already active
      if (!$(this).hasClass('active-tab')) {
        $(this).parent().children().removeClass('active-tab');

        $(this).addClass('active-tab');

        // gets clicked tab data-tab attribute
        const $activeTab = $(this).attr('data-tab');

        $(this)
          .parent()
          .siblings()
          .children()
          .hide();

        // shows tab that has id that matches the tabs data-tab attribute
        $(`#${$activeTab}`).show();
      }
    });
  }(jQuery));
}
